import React from 'react';
import {Redirect, Route} from "react-router-dom";
import {connect} from 'react-redux'

function RouteAuthenticated({ component: Component, authToken, ...rest }) {
    return (
        <Route
            {...rest}
            render={props =>
                authToken ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: props.location }
                        }}
                    />
                )
            }
        />
    );
}

const mapStateToProps = (state) => {
    return {
        authToken: state.auth.token,
    }
};

export default connect(
    mapStateToProps,
    null
)(RouteAuthenticated);